import React from "react";

const ResendIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15.834 6.66927L12.5007 10.0026H15.0006C15.0006 12.7609 12.759 15.0026 10.0007 15.0026C9.15898 15.0026 8.35898 14.7943 7.66732 14.4193L6.45065 15.6359C7.47565 16.2859 8.69232 16.6693 10.0007 16.6693C13.684 16.6693 16.6673 13.6859 16.6673 10.0026H19.1673L15.834 6.66927ZM5.00065 10.0026C5.00065 7.24427 7.24232 5.0026 10.0007 5.0026C10.8423 5.0026 11.6423 5.21094 12.334 5.58594L13.5506 4.36927C12.5257 3.71927 11.309 3.33594 10.0007 3.33594C6.31732 3.33594 3.33398 6.31927 3.33398 10.0026H0.833984L4.16732 13.3359L7.50065 10.0026H5.00065Z" fill="#0075AA" />
        </svg>
    )
}

export default ResendIcon;